// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

let Types = {};

let fragmentConverter = {};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function cardBrandV5_decode($$enum) {
  if ($$enum === "AMERICAN_EXPRESS" || $$enum === "VISA" || $$enum === "DISCOVER" || $$enum === "MASTERCARD") {
    return $$enum;
  }
}

let cardBrandV5_fromString = cardBrandV5_decode;

let Utils = {
  cardBrandV5_decode: cardBrandV5_decode,
  cardBrandV5_fromString: cardBrandV5_fromString
};

let node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentCardLogo_paymentCard",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "brand",
        "storageKey": null
      },
      "action": "THROW"
    }
  ],
  "type": "PaymentCard",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
